<template>
  <div class="dt-wrap">

    <!-- ── Barra superior: nome + filtro ── -->
    <div class="dt-topbar">
      <div class="dt-topbar-left">
        <div class="dt-video-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="3" stroke="#E86A10" stroke-width="2"/><path d="M10 9l5 3-5 3V9z" fill="#E86A10"/></svg>
        </div>
        <div>
          <div class="dt-video-name">{{ vsls[0] != null ? vsls[0].vsl_name : '–' }}</div>
          <div class="dt-video-sub">Relatório de performance do vídeo</div>
        </div>
      </div>

      <div class="dt-topbar-right" v-if="$route.name === 'analytics'">
        <!-- Pills de período -->
        <div class="dt-period-pills">
          <button v-for="opt in options" :key="opt.value" type="button" class="dt-pill" :class="{ 'dt-pill-on': value === opt.value && !customRange }" @click="selectPeriod(opt.value)">{{ opt.label }}</button>
          <button type="button" class="dt-pill" :class="{ 'dt-pill-on': customRange }" @click="customRange = !customRange">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/><path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Período
          </button>
        </div>

        <button type="button" class="dt-refresh-btn" @click="getDataFilter(value)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M23 4v6h-6M1 20v-6h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
    </div>

    <!-- Seletor de período personalizado -->
    <div v-if="customRange && $route.name === 'analytics'" class="dt-daterange">
      <div class="dt-daterange-inner">
        <div class="dt-dr-field">
          <label class="dt-dr-label">Data inicial</label>
          <input v-model="startDate" type="date" class="dt-dr-input">
        </div>
        <div class="dt-dr-sep">→</div>
        <div class="dt-dr-field">
          <label class="dt-dr-label">Data final</label>
          <input v-model="endDate" type="date" class="dt-dr-input">
        </div>
        <button type="button" class="dt-dr-btn" :disabled="endDate <= startDate && endDate !== ''" @click="getFilterDataIntervalo">
          Aplicar filtro
        </button>
      </div>
    </div>

    <!-- ── 4 KPI Cards ── -->
    <div v-if="$route.name === 'analytics'" class="dt-kpis">
      <!-- Visualizações -->
      <div class="dt-kpi">
        <div class="dt-kpi-icon dt-kpi-blue">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>
        </div>
        <div class="dt-kpi-body">
          <div class="dt-kpi-label">
            Visualizações
            <el-tooltip effect="dark" content="Número de vezes que a página foi carregada com o player" placement="top">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
            </el-tooltip>
          </div>
          <div class="dt-kpi-val dt-kpi-val-blue">{{ analise != null ? analise.qtde_load : 0 }}</div>
        </div>
      </div>

      <!-- Plays -->
      <div class="dt-kpi">
        <div class="dt-kpi-icon dt-kpi-green">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 3l14 9-14 9V3z" fill="currentColor"/></svg>
        </div>
        <div class="dt-kpi-body">
          <div class="dt-kpi-label">
            Plays
            <el-tooltip effect="dark" content="Número de vezes que os usuários iniciaram o vídeo" placement="top">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
            </el-tooltip>
          </div>
          <div class="dt-kpi-val dt-kpi-val-green">{{ analise != null ? analise.qtde_play : 0 }}</div>
        </div>
      </div>

      <!-- Play Rate -->
      <div class="dt-kpi">
        <div class="dt-kpi-icon dt-kpi-orange">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <div class="dt-kpi-body">
          <div class="dt-kpi-label">
            Play Rate
            <el-tooltip effect="dark" content="Porcentagem de plays em relação às visualizações" placement="top">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
            </el-tooltip>
          </div>
          <div class="dt-kpi-val dt-kpi-val-orange">{{ analise != null && analise.playRate != null ? analise.playRate : 0 }}%</div>
        </div>
      </div>

      <!-- Engajamento -->
      <div class="dt-kpi">
        <div class="dt-kpi-icon dt-kpi-purple">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" stroke="currentColor" stroke-width="2"/></svg>
        </div>
        <div class="dt-kpi-body">
          <div class="dt-kpi-label">
            Engajamento
            <el-tooltip effect="dark" content="Total assistido dividido por plays × duração" placement="top">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#94a3b8" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
            </el-tooltip>
          </div>
          <div class="dt-kpi-val dt-kpi-val-purple">{{ analise != null && analise.engajamento != null ? analise.engajamento : 0 }}%</div>
        </div>
      </div>
    </div>

    <!-- ── Player (largura total — gráfico de retenção já está sobreposto dentro do player) ── -->
    <div class="dt-player-card">
      <div class="dt-card-header">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="3" stroke="#E86A10" stroke-width="2"/><path d="M10 9l5 3-5 3V9z" fill="#E86A10"/></svg>
        Retenção de Audiência
        <span v-if="timeds && timeds.length > 0" class="dt-card-header-badge">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#10B981"/></svg>
          {{ timeds.length }} pontos de dados
        </span>
        <span v-else class="dt-card-header-badge dt-badge-empty">sem dados no período</span>
      </div>
      <div class="dt-player-body">
        <PersonPlayVideo
          v-model="vsls[0]"
          :analise="analise"
          :src-video="getPathVideoBucket"
          :poster-video="getFrameVideo"
          :autoplay-video="true"
          :id-muted="true"
          :timeds="timeds"
        >
          <template #message-nosuported>
            <span>Seu navegador não suporta esse vídeo</span>
          </template>
        </PersonPlayVideo>
      </div>
    </div>

  </div>
</template>

<script>
import { VslService } from '@/services/Vsl'
import { BAlert, BLink, BCard, BCardText } from 'bootstrap-vue'
import PersonPlayVideo from '@/components/PersonPlayVideo'
import { AnalyticService } from '@/services/Analytic'
import { TimedsService } from '@/services/AnalyticTimeds'
import { formatDate } from '@core/utils/dateFormat'

const analyticService = new AnalyticService()
const timedsService = new TimedsService()

export default {
  components: { PersonPlayVideo, BAlert, BLink, BCard, BCardText },
  nome: 'Videos',
  data() {
    return {
      dataIsValid: false,
      startDate: null,
      endDate: null,
      timeds: null,
      analise: null,
      vslId: this.$route.params.vslId,
      loading: false,
      vsls: [],
      errorMessage: null,
      customRange: false,
      options: [
        { value: 'hoje',        label: 'Hoje'     },
        { value: 'ontem',       label: 'Ontem'    },
        { value: 'sete_dias',   label: '7 dias'   },
        { value: 'trinta_dias', label: '30 dias'  },
        { value: 'full_dias',   label: 'Tudo'     },
      ],
      value: 'sete_dias',
    }
  },
  computed: {
    getPathVideoBucket() {
      if (['', null, undefined].indexOf(this.vsls[0]) === -1) {
        return this.vsls[0].vsl_bucket_address
      }
      return ''
    },
    getFrameVideo() {
      if (this.vsls[0] != null && this.vsls[0].vsl_frame) {
        return this.vsls[0].vsl_frame
      }
      return ''
    },
  },
  watch: {
    value(newValue) {
      if (newValue) this.getDataFilter(newValue)
    },
  },
  async created() {
    try {
      this.loading = true
      const response = await VslService.getVsl(this.vslId)
      this.vsls = response.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  async mounted() {
    if (typeof this.$route.params.vslId !== 'undefined') {
      this.vslId = this.$route.params.vslId
    }
    if (this.$route.name === 'analytics') {
      await this.getDataFilter(this.value)
    }
  },
  methods: {
    selectPeriod(val) {
      this.value = val
      this.customRange = false
    },
    getDataFilter(type_date) {
      const dataFilter = new Date()
      if (!type_date || type_date === 'sete_dias') return this.getFilterData7days(dataFilter)
      if (type_date === 'hoje')        return this.getFilterDateHoje(dataFilter)
      if (type_date === 'ontem')       return this.getFilterDataOtem(dataFilter)
      if (type_date === 'trinta_dias') return this.getFilterData30days(dataFilter)
      if (type_date === 'full_dias')   return this.getFilterDataTempoTodo(dataFilter)
    },
    async getFilterDateHoje(dataFilter) {
      const d = `${formatDate(dataFilter)}`
      await timedsService.getTimedByIdVsls(this.vslId, { start_date: d, end_date: d }).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId, { start_date: d, end_date: d }).then(resp => { this.analise = resp })
    },
    async getFilterDataOtem(dataFilter) {
      dataFilter.setDate(dataFilter.getDate() - 1)
      const d = `${formatDate(dataFilter)}`
      await timedsService.getTimedByIdVsls(this.vslId, { start_date: d, end_date: d }).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId, { start_date: d, end_date: d }).then(resp => { this.analise = resp })
    },
    async getFilterData7days(dataFilter) {
      const current = new Date()
      dataFilter.setDate(dataFilter.getDate() - (7 - dataFilter.getDay() + 1))
      await timedsService.getTimedByIdVsls(this.vslId, { start_date: `${formatDate(current)}`, end_date: `${formatDate(dataFilter)}` }).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId, { start_date: `${formatDate(current)}`, end_date: `${formatDate(dataFilter)}` }).then(resp => { this.analise = resp })
    },
    async getFilterData30days(dataFilter) {
      const current = new Date()
      dataFilter.setDate(dataFilter.getDate() - (30 - dataFilter.getDay() + 1))
      await timedsService.getTimedByIdVsls(this.vslId, { start_date: `${formatDate(current)}`, end_date: `${formatDate(dataFilter)}` }).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId, { start_date: `${formatDate(current)}`, end_date: `${formatDate(dataFilter)}` }).then(resp => { this.analise = resp })
    },
    async getFilterDataTempoTodo() {
      await timedsService.getTimedByIdVsls(this.vslId).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId).then(resp => { this.analise = resp })
    },
    async getFilterDataIntervalo() {
      await timedsService.getTimedByIdVsls(this.vslId, { start_date: this.startDate, end_date: this.endDate }).then(res => {
        this.timeds = res.data.length > 0 ? JSON.parse(JSON.stringify(res.data)) : []
      })
      await analyticService.getByIdVsl(this.vslId, { start_date: this.startDate, end_date: this.endDate }).then(resp => { this.analise = resp })
    },
  },
}
</script>

<style scoped>
/* ══════════════════════════════════════════════════════
   Detalhes — tema dark navy (igual à Análise de IA)
   ══════════════════════════════════════════════════════ */
.dt-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  background: #0D1B2E;
  min-height: 100%;
  color: #e2e8f0;
}

/* ── Topbar ── */
.dt-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  padding: 18px 24px 14px;
  gap: 16px;
  flex-wrap: wrap;
}
.dt-topbar-left { display: flex; align-items: center; gap: 12px; }
.dt-video-icon {
  width: 38px; height: 38px; border-radius: 10px;
  background: rgba(232,106,16,0.15);
  border: 1px solid rgba(232,106,16,0.3);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dt-video-name { font-size: 15px; font-weight: 800; color: #f1f5f9; }
.dt-video-sub  { font-size: 11px; color: var(--dk-text-secondary, #64748b); margin-top: 1px; }

.dt-topbar-right { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.dt-period-pills { display: flex; gap: 4px; flex-wrap: wrap; }

.dt-pill {
  display: flex; align-items: center; gap: 5px;
  padding: 5px 12px; border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.04);
  font-size: 11.5px; font-weight: 600; color: var(--dk-text-muted, #94a3b8);
  cursor: pointer; transition: all 0.2s; white-space: nowrap;
}
.dt-pill:hover { border-color: rgba(232,106,16,0.4); color: #E86A10; }
.dt-pill-on {
  background: rgba(232,106,16,0.18) !important;
  border-color: rgba(232,106,16,0.5) !important;
  color: #E86A10 !important;
}

.dt-refresh-btn {
  width: 34px; height: 34px; border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.04);
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: all 0.2s; color: var(--dk-text-secondary, #64748b); flex-shrink: 0;
}
.dt-refresh-btn:hover { border-color: rgba(232,106,16,0.4); color: #E86A10; }

/* ── Date range ── */
.dt-daterange {
  margin: 0 24px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; padding: 14px 18px;
}
.dt-daterange-inner { display: flex; align-items: flex-end; gap: 12px; flex-wrap: wrap; }
.dt-dr-field { display: flex; flex-direction: column; gap: 4px; }
.dt-dr-label {
  font-size: 10.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.07em; color: var(--dk-text-secondary, #64748b);
}
.dt-dr-input {
  border: 1px solid rgba(255,255,255,0.1); border-radius: 9px;
  padding: 8px 12px; font-size: 13px; color: #e2e8f0;
  background: rgba(255,255,255,0.06); outline: none;
  transition: border-color 0.15s; font-family: inherit;
  color-scheme: dark;
}
.dt-dr-input:focus { border-color: rgba(232,106,16,0.5); background: rgba(255,255,255,0.08); }
.dt-dr-sep { font-size: 14px; color: var(--dk-text-secondary, #475569); padding-bottom: 8px; }
.dt-dr-btn {
  padding: 9px 18px; border-radius: 9px; border: none;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; transition: opacity 0.15s;
}
.dt-dr-btn:hover:not(:disabled) { opacity: 0.88; }
.dt-dr-btn:disabled { opacity: 0.35; cursor: not-allowed; }

/* ── KPI Cards ── */
.dt-kpis {
  display: grid; grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.dt-kpi {
  padding: 20px 24px;
  border-right: 1px solid rgba(255,255,255,0.06);
  display: flex; align-items: center; gap: 14px;
  transition: background 0.2s;
}
.dt-kpi:last-child { border-right: none; }
.dt-kpi:hover { background: rgba(255,255,255,0.02); }

.dt-kpi-icon {
  width: 44px; height: 44px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dt-kpi-blue   { background: rgba(59,130,246,0.12);  color: #3B82F6; }
.dt-kpi-green  { background: rgba(16,185,129,0.12);  color: #10B981; }
.dt-kpi-orange { background: rgba(232,106,16,0.12);  color: #E86A10; }
.dt-kpi-purple { background: rgba(139,92,246,0.12);  color: #8B5CF6; }

.dt-kpi-body { flex: 1; min-width: 0; }
.dt-kpi-label {
  display: flex; align-items: center; gap: 5px;
  font-size: 10.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.8px; color: var(--dk-text-secondary, #64748b); margin-bottom: 6px;
}
.dt-kpi-val {
  font-size: 30px; font-weight: 900; line-height: 1; letter-spacing: -0.02em;
}
.dt-kpi-val-blue   { color: #3B82F6; }
.dt-kpi-val-green  { color: #10B981; }
.dt-kpi-val-orange { color: #E86A10; }
.dt-kpi-val-purple { color: #8B5CF6; }

/* ── Player card ── */
.dt-player-card {
  margin: 4px 24px 24px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px;
  overflow: hidden;
}
.dt-card-header {
  display: flex; align-items: center; gap: 8px;
  padding: 13px 18px;
  font-size: 10.5px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 1px; color: var(--dk-text-muted, #94a3b8);
  border-bottom: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
}
.dt-card-header-badge {
  margin-left: auto;
  display: flex; align-items: center; gap: 4px;
  background: rgba(16,185,129,0.12); color: #10B981;
  border: 1px solid rgba(16,185,129,0.25);
  font-size: 10px; font-weight: 800;
  padding: 3px 8px; border-radius: 6px;
}
.dt-badge-empty {
  background: rgba(255,255,255,0.04); color: var(--dk-text-secondary, #475569);
  border-color: rgba(255,255,255,0.08);
}
.dt-player-body { padding: 0; }

/* ── Responsivo ── */
@media (max-width: 900px) {
  .dt-kpis { grid-template-columns: repeat(2, 1fr); }
  .dt-kpi  { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.06); }
  .dt-topbar { padding: 14px 16px; }
  .dt-player-card { margin: 4px 12px 16px; }
}
@media (max-width: 480px) {
  .dt-kpis { grid-template-columns: 1fr; }
  .dt-daterange { margin: 0 12px; }
}
</style>
